import { StrictMode, Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import configureStore from "./store/store";
import "./sentryinit.tsx";
import * as Sentry from "@sentry/react";
import Loader from "../src/components/UI/Loader";
import "./assets/scss/style.scss";
import "../mixpanel";
import { GrnErrorBoundary } from "./pages/GrnErrorBoundary.tsx";
import setupLocatorUI from "@locator/runtime";
import './index.css';
//import App from "./App.tsx";
//import { AuthProvider } from "react-oidc-context";
//import { oidcConfig } from "../authConfig.ts";
const App = lazy(() => import("./App"));
const MaintenancePage = lazy(() =>
  import("./components/ErrorScreen/MaintenancePage.tsx"));
const isMaintenanceMode = process.env.SYSTEM_MAINTENANCE_MODE === "true";
const { store, persistor } = configureStore();
const base_name = process.env.BASE_NAME;

if (process.env.CURRENT_ENV === "local") {
  setupLocatorUI();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* <AuthProvider {...oidcConfig}> */}
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<Loader block />}>
          <Router basename={base_name}>
            <Sentry.ErrorBoundary fallback={<GrnErrorBoundary />}>
              {isMaintenanceMode ? <MaintenancePage/> : <App />}
            </Sentry.ErrorBoundary>
          </Router>
        </Suspense>
      </PersistGate>
    </Provider>
    {/* </AuthProvider> */}
  </StrictMode>,
);
